module.exports = __webpack_public_path__ + "img/CompScope_Mag_1_Focus_0.1f764f59.png";